import windowFk from "../client/windowFk";
var subscribeFnMap = new Map();

/**
 * Cache callback function
 * @param key map key
 * @param fn callback function
 * @returns
 */
export var pushSubscribeFn = function pushSubscribeFn(key, fn) {
  if (subscribeFnMap.get(key)) {
    var callBackFnArray = subscribeFnMap.get(key);
    callBackFnArray.push(fn);
    return;
  }
  subscribeFnMap.set(key, [fn]);
};

/**
 * Excution cache function
 * @param key map key
 * @returns
 */
export var popSubscribeFn = function popSubscribeFn(key, type, e, config) {
  // No subscription exists
  var callBackFnArray = subscribeFnMap.get(key);
  if (!(callBackFnArray !== null && callBackFnArray !== void 0 && callBackFnArray.length)) {
    return;
  }
  if (type === 'remove') {
    while (callBackFnArray !== null && callBackFnArray !== void 0 && callBackFnArray.length) {
      callBackFnArray.pop();
    }
    return;
  }

  // Source consistency
  if (e.origin === windowFk.getWindow().origin && !(config !== null && config !== void 0 && config.coincidentOrigin)) {
    return;
  }

  // Execute callback
  while (callBackFnArray !== null && callBackFnArray !== void 0 && callBackFnArray.length) {
    var _data;
    if ((_data = e.data) !== null && _data !== void 0 && _data.payLoad) {
      var _data2;
      callBackFnArray.pop()(JSON.parse((_data2 = e.data) === null || _data2 === void 0 ? void 0 : _data2.payLoad));
    } else {
      callBackFnArray.pop()();
    }
  }
};